import { useContext, useEffect, useState } from "react";
import {
  alpha
} from "@mui/material";
import { useParams } from "react-router-dom";
import { TestContext } from "../../context/test_context";
import { MetricsContext } from "../../context/metrics_context";
import LoadBox from "../../components/global/LoadBox";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Typography,
  Button,
  Stack
} from "@mui/material";
import {
  DataGrid,
  GridRowsProp,
  GridColDef,
  GridRenderCellParams
} from "@mui/x-data-grid";
import TestGauge from "../../components/test/TestGauge";
import GaugeChart from "react-gauge-chart";
import TestButtonSet from "../../components/test/TestButtonSet";
import { list } from "postcss";
import { useMode } from "../../theme";
import useAuth from "../../hooks/auth_hook";
import TestVideoCard from "../../components/test/TestVideoCard";
import { localizedTimeToTest } from "../../utils/time_calculators";
import { ThumbnailTitleTest } from "../../context/models";


const CustomTooltip = ({ active, payload, label }: any) => {
  if (active && payload && payload.length) {
    return (
      <div className="custom-tooltip">
        <p className="label">{`${label} : ${payload[0].value}`}</p>
      </div>
    );
  }

  return null;
};


function TestGrid({ tests, isPlaying }: any) {

  const { getMetrics, metrics_loading } = useContext(MetricsContext);
  const [metrics, setMetrics] = useState<any>({});

  useEffect(() => {
    tests.map((test: ThumbnailTitleTest, index: number) => {
      handleGetMetrics(test.id);
    });
  }, [tests]);
  console.log("Metrics: ");
  console.log(metrics);


  function handleGetMetrics(testId: string) {
    getMetrics(testId).then((this_tests_metrics: any) => {
      setMetrics((prevMetrics: any) => {
        // Add or update the metric for the given testId
        return {
          ...prevMetrics,  // Preserve previous metrics
          [testId]: this_tests_metrics  // Add or update the metric for the testId
        };
      });
    });
  }


  let rows: any = [];
  {
    tests.map((test: ThumbnailTitleTest, index: number) => {
      const row_metrics = metrics[test.id];

      if (row_metrics && row_metrics.data && row_metrics.data.rows.length > 0) {
        console.log(row_metrics.data);
        const row = {
          id: test.id ? test.id : "Test Not Completed",
          thumbnail_and_title: test ? test : "Test Not Completed",
          start_date: localizedTimeToTest(row_metrics.start_date) ? localizedTimeToTest(row_metrics.start_date) : "Test Not Completed",
          end_date: localizedTimeToTest(row_metrics.end_date) ? localizedTimeToTest(row_metrics.end_date) : "Test Not Completed",
          ctr: row_metrics.data ? row_metrics.data.rows[0][4] : "Test Not Completed",
          impressions: row_metrics.data ? row_metrics.data.rows[0][3] : "Test Not Completed",
          avd: row_metrics.data ? row_metrics.data.rows[0][3] : "Test Not Completed",
          avp: row_metrics.data ? row_metrics.data.rows[0][4] : "Test Not Completed"
        };
        rows[index] = row;
      } else {
        // Handle the case when metrics are not available yet
        const row = {
          id: test.id,
          thumbnail_and_title: test,
          start_date: "loading...",
          end_date: "loading...",
          ctr: "loading...",
          impressions: "loading...",
          avd: "loading...",
          avp: "loading..."
        };
        rows[index] = row;
      }
    });
  }
  let rowsData: GridRowsProp = rows;

  const columns: GridColDef[] = [
    {
      field: "thumbnail_and_title",
      headerName: "Test",
      width: 250,
      renderCell: (params: GridRenderCellParams<any>) => {
        return <TestVideoCard Video={params.value} handleGetMetrics={handleGetMetrics} />;
      }
    },
    { field: "start_date", headerName: "Start Date" },
    { field: "end_date", headerName: "End Date" },
    { field: "ctr", headerName: "Click Through Rate" },
    { field: "impressions", headerName: "Impressions" },
    { field: "avd", headerName: "Average View Duration" },
    { field: "avp", headerName: "Average View P?" },
    { field: "avd_ctr", headerName: "AVD * CTR" },
    { field: "subs", headerName: "Subscribers Gained" },
    { field: "comments", headerName: "Comments" },
    { field: "shares", headerName: "Shares" },
    { field: "likes", headerName: "Likes" },
    { field: "views", headerName: "Views" },
    { field: "members", headerName: "New Members" },
    { field: "revenue", headerName: "Increase in Revenue" }
  ];

  // if (!metrics) return (<Box className={'w-[250px]'}><LoadBox loading={true}><Box></Box></LoadBox></Box>)

  return (
    <Box
      sx={{
        padding: 2,
        width: "100%"
      }}
    >
      <DataGrid
        sx={{
          boxShadow: `0px 0px 5px 0px ${alpha("#000000", 0.3)}`,
          overflowX: "scroll"
        }}
        autosizeOnMount={true}
        getRowHeight={() => "auto"}
        rows={rowsData}
        columns={columns}
      />
    </Box>
  );
}


function TestPage() {
  const { testid } = useParams();
  const { getTestGroup, loading } = useContext(TestContext);
  const [testgroup, setTestGroup] = useState([]);
  const [tests, setTests] = useState<any>([]);

  const calculateCurrentTest = (tests: any) => {

    if (tests.filter((test: any) => test.tested).length === tests.length) {
      return tests[tests.length - 1];
    }
    return tests.find((test: any) => test.active) || tests[0];
  };
  const currentTest = calculateCurrentTest(tests);
  useEffect(() => {
    // console.log(testid);
    getTestGroup(testid).then((testgroup: any) => {
      setTestGroup(testgroup);
      setTests(testgroup.tests);
    });
  }, []);

  // console.log(testgroup)

  if (!testgroup) {
    return <LoadBox loading={true}>Loading</LoadBox>;
  }


  return (
    // <LoadBox loading={test_loading && metrics_loading}>
    <LoadBox loading={loading}>
      <Box sx={{ flexGrow: 1, p: 2 }}>
        <Box
          sx={{
            mb: 4,
            display: "flex",
            justifyContent: "flexStart",
            pl: 2
          }}
        >
          <TestButtonSet testgroup={testgroup} setTestGroup={setTestGroup} />
        </Box>
        <Box
          sx={{
            mb: 4,
            display: "flex",
            justifyContent: "flexStart",
            pl: 2
          }}
        >
          <Button
            href={`https://www.youtube.com/watch?v=${currentTest?.video_id}`}
            target="_blank"
            variant="contained"
          >
            Link to video
          </Button>
        </Box>
        <TestGrid tests={tests} />
      </Box>
    </LoadBox>
  );
}

export default TestPage;